export default __webpack_public_path__ + "static/media/strawberry.f7850b3b.png";